import Vue from "vue";

const getDefaultState = () => {
  return {
    Counts: [],
    //field: "name",
    //whereField: "role",
    //whereValue: "superviseur",
    collection: "counts",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.Counts = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async GetAll({ commit, dispatch }) {
    // start requête
    commit("SET_LISTE", []);

    commit("Loading/START_BUSY_STATE", "Counts GetAll", { root: true });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection("counts")
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "Counts.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "Counts.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  Counts: (state) => {
    return state.Counts;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
